export default "__VITE_ASSET__1ab35bb5__"